module.exports = __webpack_public_path__ + "res/12-img_game_bg.8d509da616d830848eb6d383770e0ace.png";